// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"50028078","185":"b288bacb"}[chunkId] + ".chunk.js";
};